import React from 'react';
import { getStrategyOptions } from '../utils/marketplaceStrategies';

function StrategyToggle({ checked, onChange, label, description }) {
  return (
    <div className="flex items-start justify-between gap-4 py-1">
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-gray-700">{label}</div>
        {description ? (
          <p className="text-xs text-gray-500 mt-0.5 leading-snug">{description}</p>
        ) : null}
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        onClick={() => onChange(!checked)}
        className={`shrink-0 w-11 h-6 rounded-full relative transition-colors ${
          checked ? 'bg-indigo-500' : 'bg-gray-300'
        }`}
      >
        <span
          className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-all ${
            checked ? 'right-0.5' : 'left-0.5'
          }`}
        />
      </button>
    </div>
  );
}

/**
 * Форма стратегии биддера для Ozon / Avito — стиль как StrategySettingsForm (WB).
 */
export default function MarketplaceStrategyForm({
  marketplace,
  values,
  onChange,
  showBudget = true,
  showBidLimits = true,
  showStockThreshold = false,
}) {
  const set = (key, val) => onChange({ ...values, [key]: val });
  const options = getStrategyOptions(marketplace);
  const current = options.find((o) => o.value === values.strategy_type) || options[0];

  return (
    <div className="space-y-4">
      <StrategyToggle
        checked={values.bidder_enabled}
        onChange={(v) => set('bidder_enabled', v)}
        label="Включить биддер"
      />
      <StrategyToggle
        checked={values.automation_enabled}
        onChange={(v) => set('automation_enabled', v)}
        label="Автоматизация 24/7"
        description="Корректировка ставок по расписанию без ручного вмешательства"
      />
      <div>
        <label className="block mb-1 text-gray-700">Тип стратегии</label>
        <select
          value={values.strategy_type}
          onChange={(e) => set('strategy_type', e.target.value)}
          className="glass-input w-full"
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
      {current && (
        <div>
          <label className="block mb-1 text-gray-700">{current.targetLabel}</label>
          <input
            type="number"
            value={values.target_value}
            onChange={(e) => set('target_value', e.target.value)}
            className="glass-input w-full"
            step="0.01"
            placeholder={current.placeholder || ''}
          />
        </div>
      )}
      {showBidLimits && marketplace !== 'avito_listing' && (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block mb-1 text-gray-700">Мин. ставка</label>
            <input
              type="number"
              value={values.min_bid}
              onChange={(e) => set('min_bid', e.target.value)}
              className="glass-input w-full"
              step="0.01"
            />
          </div>
          <div>
            <label className="block mb-1 text-gray-700">Макс. ставка</label>
            <input
              type="number"
              value={values.max_bid}
              onChange={(e) => set('max_bid', e.target.value)}
              className="glass-input w-full"
              step="0.01"
            />
          </div>
        </div>
      )}
      {showBudget && (
        <div>
          <label className="block mb-1 text-gray-700">Дневной бюджет, ₽</label>
          <input
            type="number"
            value={values.daily_budget}
            onChange={(e) => set('daily_budget', Number(e.target.value))}
            className="glass-input w-full"
            min="0"
          />
        </div>
      )}
      {showStockThreshold && (
        <div>
          <label className="block mb-1 text-gray-700">Порог остатка, шт</label>
          <input
            type="number"
            value={values.stock_threshold}
            onChange={(e) => set('stock_threshold', e.target.value)}
            className="glass-input w-full"
            min="0"
            placeholder="по умолчанию 10"
          />
          <p className="text-xs text-gray-500 mt-1">
            При низком остатке ставка снижается (как на WB).
          </p>
        </div>
      )}
    </div>
  );
}
